import { cn } from './cn.js'

export interface StepperProps {
  value: number
  onChange: (next: number) => void
  min?: number
  max?: number
  className?: string
}

/**
 * −/+ around a count. The buttons draw at 32px to keep list rows dense, and
 * carry an invisible before-layer that takes the tap target to 44px.
 */
export function Stepper({ value, onChange, min = 0, max, className }: StepperProps) {
  return (
    <div className={cn('flex items-center gap-1', className)}>
      <StepButton
        label="Mažiau"
        disabled={value <= min}
        onPress={() => onChange(value - 1)}
        glyph="−"
      />
      <span className="tnum w-5 text-center text-sm text-ink">{value}</span>
      <StepButton
        label="Daugiau"
        disabled={max != null && value >= max}
        onPress={() => onChange(value + 1)}
        glyph="+"
      />
    </div>
  )
}

function StepButton({
  label,
  glyph,
  disabled,
  onPress,
}: {
  label: string
  glyph: string
  disabled?: boolean
  onPress: () => void
}) {
  return (
    <button
      type="button"
      aria-label={label}
      disabled={disabled}
      onClick={onPress}
      className={cn(
        'relative h-8 w-8 select-none rounded-[var(--radius-control)] border border-line text-base text-dim',
        'transition-colors duration-[140ms] active:bg-raised disabled:opacity-30',
        "before:absolute before:-inset-1.5 before:content-['']",
      )}
    >
      {glyph}
    </button>
  )
}
